var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewTimelineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4218 5.48301L1.42187 5.48323C1.69972 6.26642 2.20852 6.92304 2.73025 7.59633C2.83208 7.72775 2.93441 7.8598 3.03561 7.99355L3.71127 8.77103L3.71142 8.77121C3.85192 8.93339 3.99791 8.99844 4.12819 8.99844C4.25674 8.99844 4.40272 8.93357 4.54343 8.77119L4.54368 8.7709L5.22082 7.99348C5.32101 7.86107 5.42228 7.73031 5.52307 7.60017C6.04547 6.92562 6.55491 6.26783 6.83457 5.48304C7.23015 4.37123 7.12789 3.28736 6.64545 2.48651C6.16506 1.68908 5.29896 1.15675 4.12819 1.15675C2.9566 1.15675 2.09012 1.68912 1.60975 2.48652C1.12732 3.28733 1.02542 4.37119 1.4218 5.48301ZM5.54622 4.12732C5.54622 4.90576 4.90913 5.53611 4.12819 5.53611C3.34565 5.53611 2.71015 4.90565 2.71015 4.12732C2.71015 3.34734 3.34576 2.71853 4.12819 2.71853C4.90901 2.71853 5.54622 3.34723 5.54622 4.12732Z",
    fill: "#FFD772",
    stroke: "black",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12698 11.6284C3.26279 11.6284 2.56406 12.3285 2.56406 13.1913C2.56406 14.0557 3.2627 14.7543 4.12698 14.7543C4.98982 14.7543 5.6899 14.0556 5.6899 13.1913C5.6899 12.3286 4.98973 11.6284 4.12698 11.6284Z",
    fill: "#A7E9A6",
    stroke: "black",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6153 11.6284C13.7525 11.6284 13.0523 12.3286 13.0523 13.1913C13.0523 14.0556 13.7524 14.7543 14.6153 14.7543C15.4781 14.7543 16.1782 14.0556 16.1782 13.1913C16.1782 12.3286 15.478 11.6284 14.6153 11.6284Z",
    fill: "#A7E9A6",
    stroke: "black",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2004 8.77117L14.2001 8.7709L13.523 7.99349C13.4227 7.86096 13.3214 7.73009 13.2205 7.59984C12.6982 6.92542 12.1889 6.26774 11.9093 5.4831L14.2004 8.77117ZM14.2004 8.77117C14.3411 8.93357 14.4871 8.99844 14.6157 8.99844C14.7459 8.99844 14.8919 8.93341 15.0325 8.77119L15.0326 8.77103M14.2004 8.77117L15.0326 8.77103M15.0326 8.77103L15.7083 7.99355C15.8094 7.85981 15.9118 7.72778 16.0136 7.59637C16.5353 6.92307 17.0441 6.26644 17.3219 5.48324L17.322 5.4831M15.0326 8.77103L17.322 5.4831M17.322 5.4831C17.7176 4.37123 17.6157 3.28733 17.1335 2.48649M17.322 5.4831L17.1335 2.48649M17.1335 2.48649C16.6533 1.6891 15.7872 1.15675 14.6157 1.15675M17.1335 2.48649L14.6157 1.15675M14.6157 1.15675C13.4449 1.15675 12.5788 1.68908 12.0984 2.48651M14.6157 1.15675L12.0984 2.48651M12.0984 2.48651C11.616 3.28736 11.5137 4.37123 11.9093 5.48304L12.0984 2.48651ZM16.0337 4.12732C16.0337 4.90565 15.3982 5.53611 14.6157 5.53611C13.8347 5.53611 13.1976 4.90577 13.1976 4.12732C13.1976 3.34722 13.8349 2.71853 14.6157 2.71853C15.3981 2.71853 16.0337 3.34734 16.0337 4.12732Z",
    fill: "#75CEF8",
    stroke: "black",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6704 13.1913C26.6704 12.3285 25.9703 11.6284 25.1075 11.6284C24.2432 11.6284 23.5445 12.3284 23.5445 13.1913C23.5445 14.0557 24.2432 14.7543 25.1075 14.7543C25.9703 14.7543 26.6704 14.0556 26.6704 13.1913Z",
    fill: "#A7E9A6",
    stroke: "black",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2695 1.02033C14.3855 1.00959 14.5019 1.0044 14.6183 1.0048C17.0614 1.0048 18.2829 3.23555 17.466 5.53143C17.1234 6.49721 16.4382 7.27853 15.8275 8.08615L15.1485 8.86747C14.9872 9.05352 14.8028 9.14648 14.6183 9.14648C14.5268 9.14648 14.4354 9.12324 14.347 9.07676",
    stroke: "black",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12698 14.9043C5.06946 14.9043 5.8399 14.1354 5.8399 13.1913C5.8399 12.2488 5.06946 11.4784 4.12698 11.4784C3.18291 11.4784 2.41406 12.2488 2.41406 13.1913C2.41406 14.1354 3.18291 14.9043 4.12698 14.9043Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9024 13.1914H5.83984",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6153 14.9043C15.5593 14.9043 16.3282 14.1354 16.3282 13.1913C16.3282 12.2488 15.5593 11.4784 14.6153 11.4784C13.6728 11.4784 12.9023 12.2488 12.9023 13.1913C12.9023 14.1354 13.6728 14.9043 14.6153 14.9043Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3923 13.1914H16.3281",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1074 14.9043C26.0499 14.9043 26.8204 14.1354 26.8204 13.1913C26.8204 12.2488 26.0499 11.4784 25.1074 11.4784C24.1634 11.4784 23.3945 12.2488 23.3945 13.1913C23.3945 14.1354 24.1634 14.9043 25.1074 14.9043Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0871 8.86941L13.4065 8.08809C12.7958 7.28047 12.1121 6.49915 11.768 5.53337C10.9511 3.23749 12.1741 1.00674 14.6157 1.00674C17.0588 1.00674 18.2803 3.23749 17.4633 5.53337C17.1208 6.49915 16.4355 7.28047 15.8248 8.08809L15.1458 8.86941C14.8234 9.24145 14.4095 9.24145 14.0871 8.86941Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6157 5.38477C15.3164 5.38477 15.8837 4.8205 15.8837 4.12597C15.8837 3.42997 15.3164 2.86723 14.6157 2.86723C13.915 2.86723 13.3477 3.42997 13.3477 4.12597C13.3477 4.8205 13.915 5.38477 14.6157 5.38477Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12741 5.38477C4.82653 5.38477 5.39545 4.8205 5.39545 4.12597C5.39545 3.42997 4.82653 2.86723 4.12741 2.86723C3.4267 2.86723 2.85938 3.42997 2.85938 4.12597C2.85938 4.8205 3.4267 5.38477 4.12741 5.38477Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8203 13.1914H28.2077",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02734 13.1914H2.41476",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12891 9.14698V11.4785",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6172 9.14698V11.4785",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6763 17.1504H3.46875",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63688 19.0742H2.51172",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3286 17.1504H14.1211",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2892 19.0742H13.1641",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.981 17.1504H24.7734",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9416 19.0742H23.8164",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63688 20.9961H2.51172",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2892 20.9961H13.1641",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9416 20.9961H23.8164",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3984 5.48301L22.3984 5.48323C22.6763 6.26656 23.1852 6.92328 23.7071 7.59669C23.8088 7.72799 23.9111 7.85992 24.0122 7.99355L24.6878 8.77103L24.6879 8.77119C24.8285 8.9334 24.9744 8.99844 25.1047 8.99844C25.2333 8.99844 25.3793 8.93356 25.52 8.77119L25.5202 8.7709L26.1974 7.99349C26.2977 7.86094 26.399 7.73006 26.4999 7.5998C27.0222 6.92538 27.5315 6.26769 27.8111 5.48304C28.2067 4.37123 28.1045 3.28736 27.622 2.48651C27.1416 1.68908 26.2755 1.15675 25.1047 1.15675C23.9332 1.15675 23.0667 1.68912 22.5863 2.48652C22.1039 3.28733 22.002 4.37119 22.3984 5.48301ZM26.5228 4.12732C26.5228 4.90576 25.8856 5.53611 25.1047 5.53611C24.3221 5.53611 23.6867 4.90564 23.6867 4.12732C23.6867 3.34735 24.3223 2.71853 25.1047 2.71853C25.8855 2.71853 26.5228 3.34723 26.5228 4.12732Z",
    fill: "#EB5468",
    stroke: "black",
    strokeWidth: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1079 5.38477C25.807 5.38477 26.3759 4.8205 26.3759 4.12597C26.3759 3.42997 25.807 2.86723 25.1079 2.86723C24.4072 2.86723 23.8398 3.42997 23.8398 4.12597C23.8398 4.8205 24.4072 5.38477 25.1079 5.38477Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1055 9.14698V11.4785",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTimelineIcon);
export default __webpack_public_path__ + "static/media/view-timeline-icon.fbe2ee85bb7f97d69d53e702e93f572f.svg";
export { ForwardRef as ReactComponent };